// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"3614a756","397":"6131e705","690":"72772a84","711":"1dc0cab1","714":"0ff70caf","719":"0c58686c","938":"2f4cc8d4"}[chunkId] + ".chunk.js";
};